import { useEffect } from 'react'
import { useUnsavedChangesStore } from '@/stores/unsavedChangesStore'

/**
 * Report `isDirty` into the shared unsaved-changes guard. Call this from any
 * settings section (or similar) that tracks its own dirty state -- clears
 * automatically on unmount, so switching away cleanly resets the guard even
 * if the component never explicitly sets dirty back to false itself.
 */
export function useUnsavedChangesGuard(isDirty: boolean): void {
  const setDirty = useUnsavedChangesStore((s) => s.setDirty)
  useEffect(() => {
    setDirty(isDirty)
    return () => setDirty(false)
  }, [isDirty, setDirty])
}
